import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const ProductSkeletonListContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonListContainer, style],
  });

export const ProductSkeletonListItems = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productSkeletonListItems, style],
  });

export const ListItem = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.listItem, style],
  });

export const SkeletonListItem = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.skeletonListItem, style],
  });

const styles = StyleSheet.create({
  listItem: {
    borderBottomColor: primitive.$blackOpacity10,
    borderBottomWidth: 1,
    height: 90,
    padding: spacing.$4,
    width: '100%',
  },
  productSkeletonListContainer: {
    alignItems: 'center',
    backgroundColor: primitive.$white,
    width: '100%',
  },
  productSkeletonListItems: {
    flexDirection: 'column',
    marginTop: spacing.$2,
    width: '100%',
  },
  skeletonListItem: {
    flexDirection: 'row',
  },
});
